module.exports = __webpack_public_path__ + "static/hr_ad_1-8e20701279b8b30e7a6cfe17a2ffec7d.png";